import { useRequest } from 'ahooks';
import http from '@/utils/http';
import { RequrstBack } from '@/pages/aigc/types/server';
import { queryInitStatClientConfig } from '@/pages/aigc/constants/server';
import { isEmpty, omit } from 'lodash-es';
// 获取数据口径Url
export const useGetSummarizeUrl = <T>(params?: T) => {
  const fetch = (mutateParams: any) =>
    http({
      url: '/api/v1/lida/summarize/url',
      method: 'post',
      data: mutateParams,
      rawData: true,
      ignoreCode: true,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    cacheKey: 'summarizeUrl',
    loadingDelay: 300,
    manual: true,
  });
  return {
    ...data,
  };
};
// 获取目的
export const useGetSummarizeGoal = <T>(params?: T) => {
  const fetch = (mutateParams: any) =>
    http({
      url: '/api/v1/lida/goal',
      method: 'post',
      data: {
        ...params,
        ...mutateParams,
      },
      rawData: true,
      ignoreCode: true,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    cacheKey: 'summarizeGoal',
    loadingDelay: 300,
    ready: !isEmpty(params?.summary) && !!params,
  });
  return {
    ...data,
  };
};
// 获取可视化图表以及代码
export const useGetSummarizeVisualize = <T>(params?: T) => {
  const fetch = (mutateParams: any) => http({
    url: '/api/v1/lida/visualize',
    method: 'post',
    rawData: true,
    ignoreCode: true,
    data: {
      ...omit(params, ['loading']),
      ...mutateParams,
    },
  }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    refreshDeps: [params],
    cacheKey: 'summarizeVisualize',
    loadingDelay: 300,
    debounceWait: 800,
    ready: !isEmpty(params?.goal) && !!params && !params?.loading,
  });
  return {
    ...data,
  };
};
// 编辑可视化图表以及代码获取
export const useEditSummarizeGoal = <T>(params?: T) => {
  const fetch = (mutateParams: any) =>
    http({
      url: '/api/v1/lida/visualize/edit',
      method: 'post',
      rawData: true,
      ignoreCode: true,
      data: mutateParams,
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    cacheKey: 'summarizeEdit',
    loadingDelay: 300,
    manual: true,
  });
  return {
    ...data,
  };
};

// 底部各页签
export const useGetVisualizeExplain = <T>(
  type?: T,
  params?: { [key in string]: string },
) => {
  const typeFetchUrlKeys = {
    2: '/api/v1/lida/visualize/explain',
    3: '/api/v1/lida/visualize/evaluate',
    4: '/api/v1/lida/visualize/recommend',
  }[type as string];
  const fetch = (mutateParams: any) =>
    http({
      url: typeFetchUrlKeys,
      method: 'post',
      rawData: true,
      ignoreCode: true,
      data: {
        ...params,
        ...mutateParams,
      },
    }) as RequrstBack;
  const data = useRequest(fetch, {
    ...queryInitStatClientConfig,
    cacheKey: 'explainDetail',
    loadingDelay: 300,
    ready: !isEmpty(params?.code) && !!params,
    refreshDeps: [params],
  });
  return {
    ...data,
  };
};
